const ErrorDetails = ({ errors }: any) => {
  return (
    <>
      {Object.keys(errors || {})?.map((key) => {
        const messages = Array.isArray(errors[key]) ? errors[key] : [errors[key]];

        return (
          <div key={key}>
            {messages.filter(Boolean).map((message: any, idx: number) => (
              <p key={idx}>
                <b>{key}</b> {message}
              </p>
            ))}
          </div>
        );
      })}
    </>
  );
};

export default ErrorDetails;
